import React, { useState } from "react";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";

const FAQs = () => {
    const [openItem, setOpenItem] = useState(null);

    const handleItemClick = (index) => {
        setOpenItem((prevOpenItem) => (prevOpenItem === index ? null : index));
    };

    return (
        <div className="bg-dark py-20 font-primary font-semibold" id="scrollToFaqs">
            <div className="max-w-7xl md:p-20 rounded-3xl border relative border-gray-400 mx-auto p-8 w-[90%]">
                <div className="absolute top-0 left-[45%] overlay-glow2"></div>
                <p className="text-4xl text-light text-center pb-4">HAVE A QUESTION?</p>
                <p className="text-[1.3rem] leading-[1.75rem] text-gray-400 text-center md:px-80 font-normal">
                    Our support team will get assistance from AI-powered suggestions, making it quicker than
                    ever to handle support requests.
                </p>
                <div className="join join-vertical w-full pt-10 md:px-64">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className={`collapse rounded-xl p-8 my-4 border border-base-300 ${openItem === index ? "open" : ""
                                }`}
                        >
                            <div
                                className="flex justify-between p-2 md:p-4 items-center cursor-pointer"
                                onClick={() => handleItemClick(index)}
                            >
                                <div className="text-gray-300 md:text-[1.4rem] md:leading-[1.75rem] font-bold">{faq.question}</div>
                                {openItem === index ? (
                                    <BsChevronUp className="text-white text-xl" />
                                ) : (
                                        <BsChevronDown className="text-white text-xl" />
                                )}
                            </div>
                            <div className={`collapse-content font-semibold text-[1.1rem] leading-[1.5rem] text-gray-300 ${openItem === index ? "open" : ""}`}>
                                <p>{faq.answer}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

const faqs = [
    {
        question: "What are the system requirements to use Mitko?",
        answer:
            "RyteBot is a cloud-based AI tool, which means you only need a stable internet connection and a compatible web browser to access and use it. It works on various devices, including desktops, laptops, tablets, and mobile phones.",
    },
    {
        question: "Is there a free trial or a subscription plan for RyteBot?",
        answer: "hello",
    },
    {
        question: "Can RyteBot guarantee plagiarism-free content?",
        answer: "hello",
    },
    {
        question: "What types of content can RyteBot create?",
        answer: "hello",
    },
    {
        question: "What is RyteBot?",
        answer: "hello",
    },
];

export default FAQs;
